<template>
  <div :class="[colClass, props.class]">
    <slot></slot>
  </div>
</template>
  
  <script setup>
  import { computed } from 'vue';
  
  const props = defineProps({
    cols: {
      type: String,
      default: ''
    }, 
    class: {
      type: String,
      default: ''
    }
  });
  
  const colClass = computed(() => {
    return props.cols ? `col-md-${props.cols} col-sm-12` : 'col';
  });
  </script>